export enum ApplicationChannel {
  'WEB' = 'WEB',
  'POS' = 'POS',
}
